import { useEffect, useState } from "react";
import { useListings } from "@/hooks/use-listings";

export const HeroCarousel = () => {
  const { listings } = useListings();
  const images = listings.filter((item) => item.images[0]).slice(0, 4).map((item) => ({ src: item.images[0], title: item.title }));
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (images.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const interval = window.setInterval(() => setIndex((previous) => (previous + 1) % images.length), 6000);
    return () => window.clearInterval(interval);
  }, [images.length]);
  return <div className="absolute inset-0 overflow-hidden bg-slate-950">
    {images.length ? images.map((photo, position) => <img key={photo.src} src={photo.src} alt={photo.title} fetchPriority={position === 0 ? "high" : "auto"} loading={position === 0 ? "eager" : "lazy"} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 motion-reduce:transition-none ${position === index % images.length ? "opacity-100" : "opacity-0"}`} />) : <div aria-hidden="true" className="corner-hero-architecture"><span /><span /><span /></div>}
    <div className="absolute inset-0 bg-gradient-to-r from-slate-950/70 to-slate-950/40" />
  </div>;
};
